require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-15-plus-programming-books-to-keep-on-your-shelf.json") })
        }
      }, "path---blog-15-plus-programming-books-to-keep-on-your-shelf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-15-plus-programming-books-to-keep-on-your-shelf!./.cache/json/blog-15-plus-programming-books-to-keep-on-your-shelf.json
// module id = 544
// module chunks = 231608221292675